import _ from "lodash";
import { DEFAULT_USER_AUTH_TOKEN } from "./consts";
import { IOrderGetListResult } from "api/OrderApi/interfaces-result";
import moment from "moment";

export const getStoredUserAuthToken: () => string = (): string => {
  const authToken: string | null =
    window.sessionStorage.getItem("UserAuthToken");
  if (authToken) {
    return authToken;
  }
  return DEFAULT_USER_AUTH_TOKEN;
};

export const getFormattedAddress: (data: IOrderGetListResult) => string = (
  data: IOrderGetListResult
): string => {
  const appartmentNoText: string = data.apartmentNo
    ? `/${data.apartmentNo}`
    : "";
  const zipCodeText: string = _.trim(_.trim(data.zipCode ?? "", "00-000"));
  const address = `${data.street ?? ""} ${
    data.streetNo ?? "-"
  }${appartmentNoText}, ${zipCodeText} ${data.city}`;
  return address;
};

const directions: { range: [number, number]; direction: string }[] = [
  { range: [0, 22.5], direction: "N" },
  { range: [22.5, 67.5], direction: "NE" },
  { range: [67.5, 112.5], direction: "E" },
  { range: [112.5, 157.5], direction: "SE" },
  { range: [157.5, 202.5], direction: "S" },
  { range: [202.5, 247.5], direction: "SW" },
  { range: [247.5, 292.5], direction: "W" },
  { range: [292.5, 337.5], direction: "NW" },
  { range: [337.5, 360], direction: "N" },
];

export const getOrderGeographicalDirection = (bearingAngle: number): string => {
  for (const direction of directions) {
    if (bearingAngle >= direction.range[0] && bearingAngle < direction.range[1]) {
      return direction.direction;
    }
  }
  return "-";
};

export const getShiftDateFromDate = (date: moment.Moment): moment.Moment => {
  const startOfDay = moment(date).startOf('day');
  let result = startOfDay.clone();
  if (date.isBefore(startOfDay.clone().add(6.5, 'hours'))) {
    result = result.subtract(1, 'days');
  }
  return result;
};

export const getShiftStartDateFromDate = (date: moment.Moment): moment.Moment => {
  const startOfDay = moment(date).startOf('day');
  let result = startOfDay.clone();
  if (date.isBefore(startOfDay.clone().add(6.5, 'hours'))) {
    result = result.subtract(1, 'days');
  }
  return result.add(6.5, 'hours');
};
